<template>
	<div>
		<!--导航条-->
		<div class="yg_nav">
			<!-- <div class="yg-l"> -->
			<!-- <span class="yg_nav1_1">活动管理</span> -->
			<!--切换条-->
			<!--                <div class="qiehu">
                    <ul>
                        <li class="sy"><a href="javascript:void(0)">首页</a></li>
                        <li class="hd"><a href="javascript:void(0)" @click="jump('hdshezhi')">活动设置</a></li>
                    </ul>
                </div> -->
			<!--切换条-->
			<!-- </div> -->
			<div class="yg-r">
				<label for="suo" style="display: block;float: right;margin-bottom: 0;width: 224px;height: 28px; font-size: 12px;position: relative;margin-top:15px">
					<input id="suo" style="width: 192px;height: 30px;border-radius: 14px 0 0 14px;border: 1px solid #8CBB77;padding-left: 18px"
					 type="text" placeholder="在此输入姓名" v-model="zhi" @keyup.enter="suo">
					<el-button style="padding: 8px;
						background-color: #8CBB77;
						border-radius: 0 14px 14px 0;
						position: absolute;
						top: -1px;
						right:1px;
						cursor: pointer;
						border-color:white;"
					 type="success" @click="suo" icon="el-icon-search"></el-button>
				</label>

			</div>

		</div>

		<div style="width: 100%;height: 2px;border-bottom: 1px solid #ecedff; "></div>
		<!--下边线-->

		<!--导航条-->
		<div class="zhuti">
			<div class="zhu_l">
				<div class="huod_t" style="border-left: 4px solid #8CBB77;">活动签到</div>
				<div class="biaog1" v-for="(vo,index) in hddata">

					<div class="bia1">
						<div class="huod_ta">
							<div>日期:{{vo.start_time}}</div>
							<div>计次:{{vo.xiaohao}} 次</div>
							<div style="white-space: nowrap;text-overflow:ellipsis; overflow:hidden;">
								活动主题:{{vo.title}}
							</div>
						</div>
						<div class="hui_taR">
							<input type="button" value="结束活动" style="width:133px;
                height:34px;background:#8CBB77;color:white;margin-top:15px;
                float:right;line-height:34px;border-radius: 17px;
                margin-right: 10px;border: none;
                box-shadow:1px 1px 4px gray ;
                "
							 @click="hdjs(vo.hd_id)">
							<div style="clear: both;width: 100%;height: auto;margin-top: 15px">
								<p style="width: auto;padding: 5px;">活动介绍</p>
								<div style="width:100%;padding: 5px;line-height:20px">
									<p class="hang3">
										{{vo.jieshao}}
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="qiandaoBox">
						<div class="liebiao2" v-for="(val,index2) in vo.user">
							{{val.baobao_name}}&nbsp;
							<img style="width: 42px;vertical-align: middle" v-if="inarr(val.user_id,vo.qian_id) && val.baobao_name != null"
							 src="/static/qmsj/img/over.png" alt="" @click="qiandao(val.user_id,vo.hd_id)">
							<img style="width: 42px;vertical-align: middle" v-if="!inarr(val.user_id,vo.qian_id)" src="/static/qmsj/img/clock%20in.png"
							 alt="" @click="qiandao(val.user_id,vo.hd_id)">
						</div>
						<div style="clear: both"></div>
					</div>
				</div>
			</div>
			<div class="zhu_r">
				<div class="zhu_r1">
					<div class="huod_t">活动预约</div>
					<div class="badge2">
						<table class="table">
							<thead>
								<tr style="background:#f5f6fa">
									<th class="t_title2">姓名</th>
<!--									<th class="t_title2">月龄</th>-->
									<th class="t_title2">电话</th>
								</tr>
							</thead>
							<tbody class="tb">
								<tr v-for="(item,index) in userdata" class="trr yuy" :id="'cc'+item.user_id" style="text-align:center" @click="dian(item.user_id,item.baobao_name)">
									<td>{{item.baobao_name}}</td>
<!--									<td>{{item.yueling}}</td>-->
									<td>{{item.p_phone}}</td>
								</tr>
							</tbody>
						</table>
						<div id="aa">
							<div class="xinxi" id="xinxia">
								<div class="xinxi_1">
									<p class="xuliehao"> 1</p>
								</div>
								<div class="xinxi_2">
									<div class="xinxi_d1" style="width:130px ">时间：</div>
									<div class="xinxi_d1" style="width:100px ">计次：</div>
									<div class="xinxi_d1" style="width: auto;max-width: 190px;overflow: hidden;white-space:nowrap">活动主题:
									</div>
									<div class="xinxi_d2">
										<button class="yuyue">预约</button>
									</div>
								</div>
							</div>
							<div class="xinxi" v-for="(item,index) in yydata">
								<div class="xinxi_1">
									<p class="xuliehao">{{index+1}}</p>
								</div>
								<div class="xinxi_2">
									<div class="xinxi_d1" style="width:130px ">时间：{{item.start_time}}</div>
									<div class="xinxi_d1" style="width:100px ">计次：{{item.xiaohao}}</div>
									<div class="xinxi_d1" style="width: auto;max-width: 190px;overflow: hidden;white-space:nowrap">
										活动主题:{{item.title}}
									</div>
									<div class="xinxi_d2">
										<button class="yuyue" :class="item.check == 1 ? 'h_btn' : 'yuyue'" :id="'yuy'+item.hd_id" @click="yuy(item.hd_id)">预约</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	export default {
		data() {
			return {
				token: '', //token
				hddata: [], //活动签到信息
				zhi: '', //搜索框的值
				userdata: [], //检索出来的用户信息
				yydata: [], //可预约活动信息
				tmp_uid: '', //记录点击的预约用户ID
				tmp_bbname: '', //记录点击的预约用户姓名
			}
		},
		methods: {
			jump(d) {
				this.$router.push(d);
			},
			inarr: function(user_id, qian_id) {
				var tag = false;
				for (var i = 0; i < qian_id.length; i++) {
					if (qian_id[i] == user_id) {
						tag = true;
						break;
					}
				}
				return tag;
			},
			yuy: function(hd_id) {
				let self = this;
				this.$confirm('是否为用户 ' + self.tmp_bbname + ' 预约此活动?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var eleid = '#yuy' + hd_id;
					$.ajax({
						"type": "post",
						"url": process.env.apiUrl + "saas/activity/yuy",
						"dataType": "json",
						"data": {
							"hd_id": hd_id,
							"user_id": self.tmp_uid,
							'token': self.token,
						},
						success: function(data) {
							if (data.status == 3) {
								$(eleid).css('background', '#b3b3b3')
								$(eleid).attr("disabled", 'disabled');
								self.add("该会员已经预约过了本活动");
							} else if (data.status == 1) {
								$(eleid).css('background', '#b3b3b3')
								$(eleid).attr("disabled", 'disabled');
								self.$message.success(data.msg);
								self.showhddata()
							} else {
								self.$message.error(data.msg);
							}
						},
					});
				}).catch(() => {});
			},
			dian: function(user_id, username) {
				$('.xinxi').css('display', 'block')
				$('.xinxi>.yuyue').css('background', '#8CBB77')
				let self = this;
				self.tmp_uid = user_id;
				self.tmp_bbname = username;
				self.yydata = [];
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/activity/dian",
					"dataType": "json",
					"data": {
						"status": 1,
						'token': self.token,
						'user_id':user_id
					},
					success: function(data) {
						if (data.status == 1) {
							$("#xinxia").hide();
							self.yydata = data.data;
							$(".trr").css("background", '');
							$("#cc" + self.tmp_uid).css("background", '#c9e8fc');
							$('.xinxi>.yuyue').css('background', 'red')
						}else{
							self.yydata = [];
						}
					},
				});
			},
			suo: function() {
				let self = this;
				if (self.zhi.length < 1) {
					self.$message.error("请输入姓名进行查询");
				}
				self.yydata = [];
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/activity/search",
					"dataType": "json",
					"data": {
						"zhi": self.zhi,
						'token': self.token
					},
					success: function(data) {
						if (data.status == 1) {
							self.userdata = data.data;
						} else {
							self.userdata = [];
						}
					},
				});
			},
			hdjs: function(hd_id) { //结束活动
				let self = this;
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/activity/hdjs",
					"dataType": "json",
					"data": {
						"hd_id": hd_id,
						'token': self.token,
					},
					success: function(data) {
						if (data.status == 1) {
							self.showhddata();
						} else {
							self.$message.error(data.msg);
						}
					},
				});
			},
			qiandao: function(user_id, hd_id) {
				let self = this;
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/activity/qiandao",
					"dataType": "json",
					"data": {
						"user_id": user_id,
						"hd_id": hd_id,
						'token': self.token,
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message.success(data.msg);
							self.showhddata();
						} else if (data.status == 2) {
							self.$message.error(data.msg);
						} else if (data.status == 3) {
							self.add("未检测到生效合约,无法签到");
						} else {
							self.$message.error("异常错误,请稍后重试");
						}
					},
				});
			},
			add: function(n) {
				this.$alert(n, '消息提示', {
					confirmButtonText: '确定',
				});
			},
			showhddata: function() { //获取当前活动信息
				let self = this;
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/activity/index",
					"dataType": "json",
					"data": {
						"token": self.token,
					},
					success: function(data) {
						if (data.status == 1) {
							self.hddata = data.data;
						} else {
							self.hddata = [];
						}
					},
				});
			}
		},
		mounted: function() {
			var self = this
			self.token = self.$cookies.get("token")
			self.showhddata();
		}
	}
</script>
<style scoped>
	* {
		margin: 0;
		padding: 0
	}

	a {
		text-decoration: none;
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	em,
	i {
		font-style: normal;
		font-weight: normal;
	}

	img {
		vertical-align: top;
		border: 0;
		margin: 0;
		padding: 0;
		width: 100%;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	.h1,
	.h2,
	.h3,
	.h4,
	.h5,
	.h6 {
		font-weight: 500;
		margin: 0;
		padding: 0;
	}

	* {
		margin: 0;
		padding: 0;
	}

	input,
	a {
		outline: none;
	}

	.wrap {
		min-width: 320px;
		max-width: 640px;
		margin: 0 auto;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	/*伪类清除浮动*/
	.fix {
		*zoom: 1;
	}

	.fix:after {
		display: block;
		content: "clear";
		height: 0;
		clear: both;
		overflow: hidden;
		visibility: hidden;
	}

	body {
		width: 100%;
		background: #f6f6f6;
		font-family: "微软雅黑";
		font-size: 14px;
	}

	/*导航部分*/

	.yg_nav {
		width: 93%;
		margin: 0 auto;
		height:60px;
	}

	.yg-l {
		width: 50%;
		float: left
	}

	.yg-r {
		width:100%;
		float:right
	}

	.yg_nav1_1 {
		display: block;
		float: left;
		width: 100%;
		font-size: 18px;
		height: 44px;
		line-height: 44px;

	}

	.qiehu {
		float: left;
		height: 40px;
		margin-top: 10px;
	}

	.sy {
		border-left: 1px solid #7c73bf;
		border-right: 1px solid #7c73bf;
		border-top: 1px solid #7c73bf;
		float: left;
		width: 94px;
		height: 39px;
		line-height: 39px;
		background: #ececff;
		text-align: center;
		border-radius: 8px 8px 0 0;
	}

	.sy>a {
		width: 100%;
		height: 100%;
		font-size: 14px;
		color: #a4a0d6;
	}

	.hd {
		border-left: 1px solid #7c73bf;
		border-right: 1px solid #7c73bf;
		border-top: 1px solid #7c73bf;
		float: left;
		width: 129px;
		height: 39px;
		line-height: 39px;
		margin-left: 15px;
		text-align: center;
		border-radius: 8px 8px 0 0;
		background: #7c73bf;
	}

	.hd>a {
		width: 100%;
		height: 100%;
		font-size: 14px;
		color: white;
	}

	.sousuo {
		float: right;
		width: 290px;
		height: 36px;
		margin-top: 50px;

	}

	label {
		margin: 0;
	}

	.suo {
		display: block;
		width: 100%;
		height: 100%;

	}

	.suoin {
		width: 238px;
		height: 33px;
		border: 1px solid #dbdbdb;
		border-radius: 5px;
	}

	.suosoutu {
		width: 35px;
		vertical-align: middle;
		padding-bottom: 2px;
	}

	.zhuti {
		width: 93%;
		margin: 26px auto 0;
	}

	.zhu_l {
		float: left;
		width: 50%;
		/*height: 560px;*/
		border-right: 1px solid #dbdbdb;
	}

	.zhu_r {
		width: 50%;
		float: left;
	}

	.huod_t {
		width: 100%;
		border-left: 4px solid #8CBB77;
		height: 24px;
		line-height: 24px;
		padding-left: 6px;
		font-size: 16px;
		margin-bottom: 15px;
	}

	.biaog1 {
		width: 100%;
		margin-top: 14px;
		padding-right: 16px;
	}

	.table {
		border: 1px solid #dbdbdb;
		box-shadow: 1px 1px 2px 2px #dbdbdb;
	}

	.t_title {
		height: 62px;
		padding: 0 !important;
		line-height: 62px !important;
		text-align: center;
		font-size: 14px;
	}

	.kaik {
		width: 72px;
		height: 30px;
		line-height: 30px;
		border: none;
		color: white;
		background: #b3b3b3;
	}

	.trr:hover {
		background: #c9e8fc;
	}

	.zhu_r1 {
		width: 100%;
		padding-left: 32px;
	}

	.t_title2 {
		text-align: center;
	}

	.xinxi {
		width: 100%;
		margin-top: 58px;
		height: 70px;
		border: 1px solid #dbdbdb;
		box-shadow: 1px 1px 2px 2px #dbdbdb;
	}

	.xinxi_1 {
		float: left;
		width: 7%;
		height: 68px;
		padding-top: 20px;
	}

	.xinxi_2 {
		float: left;
		width: 93%;
		min-width: 43px;
		height: 69px;
		line-height: 69px;

	}

	.xinxi_2 .xinxi_d1 {
		float: left;
	}

	.xinxi_d2 {
		float: right;
		padding-right: 10px;
	}

	.yuyue {
		width: 83px;
		height: 26px;
		line-height: 26px;
		border: none;
		color: white;
		outline:none;
		border-radius: 13px;
		box-shadow: 1px 1px 4px #999;
		background: #8CBB77;
	}

	.h_btn {
			width: 83px;
			height: 26px;
			line-height: 26px;
			border: none;
			color: white;

			border-radius: 13px;
			box-shadow: 1px 1px 4px #999;
			background: rgb(179, 179, 179);
		}

	.bia1 {
		width: 100%;
		height: 150px;
		border: 1px solid #dbdbdb;
		box-shadow: 1px 1px 2px 2px #dbdbdb;
	}

	.huod_ta {
		width: 50%;
		line-height: 50px;
		float: left;
		padding-left: 5px;
		border-left: 4px solid #78c6c5;
	}

	.huod_ta>div {
		width: 100%;
		height: auto;
		font-size: 14px;
	}

	.liebiao2 {
		width: 33%;
		height: 40px;
		line-height: 40px;
		float: left;
	}

	.hui_taR {
		width: 50%;
		float: left;
	}

	.qiandaoBox {
		width: 100%;
		height: auto;
		padding: 32px 10px 32px 10px;
		border: 1px solid #999;
		margin-top: 10px;
	}

	.xuliehao {
		width: 24px;
		height: 24px;
		text-align: center;
		line-height: 24px;
		border-radius: 12px;
		background: #8CBB77;
		color: white;
		margin: 0 auto;
	}

	.huod_t {
		width: 100%;
		border-left: 4px solid #8CBB77;
		height: 25px;
		line-height: 25px;
		padding-left: 12px;
		font-size: 18px;
		margin-bottom: 10px;
	}

	p {
		margin: 0;
		padding: 0;
	}

	body ul {
		margin-bottom: 0;
		padding: 0;
	}

	.hang1 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.hang2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.hang3 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}
</style>



// WEBPACK FOOTER //
// src/pages/huodong/hdshouye.vue